import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/back-amount-list',
      name: 'admin-back-amount-list',
      component: () => import(/* webpackChunkName: "page-admin-credit-management-back-amount-list" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "回款列表"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "授信管理"
                                        },
                                        {
                                                  name: "回款列表"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
